module.exports = __webpack_public_path__ + "static/img/glasses_01.4499f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/glasses_01.png
// module id = YRMK
// module chunks = 0